module.exports = __webpack_public_path__ + "img/立即申请.680c3272.png";